import { createAsyncThunk } from "@reduxjs/toolkit";
import apiInstance from "../../config/api";


export const createComment = createAsyncThunk('comment/create', async ({ postId, comment }) => {
    try {
        // console.log(JSON.stringify(comment))
        const request = await apiInstance.post(`/api/post/comments/${postId}`, comment);
        const response = request.data;
        // console.log('comment response ', response)
        if (response.status === 'success') {
            return response.comment
        } else {
            throw new Error(response.message)
        }
    }
    catch (error) {
        console.log('comment error ', error.message)
        throw new Error(error.message)
    }
})

export const editComment = createAsyncThunk('comment/edit', async ({ commentId, comment }) => {
    try {
        // console.log(JSON.stringify(comment))
        const request = await apiInstance.put(`/api/post/comments/${commentId}`, comment);
        const response = request.data;
        // console.log('comment response ', response)
        if (response.status === 'success') {
            return response.comment
        } else {
            throw new Error(response.message)
        }
    }
    catch (error) {
        console.log('comment error ', error.message)
        throw new Error(error.message)
    }
})

export const getPostComments = createAsyncThunk('comment/post-comments', async ({ postId, page }) => {
    try {
        const request = await apiInstance.get(`/api/post/posts/${postId}/comments?page=${page}`)
        const response = request.data
        // console.log('get comments response ', response)
        if (response.status === 'success') {
            return response
        } else {
            throw new Error(response.message)
        }
    }
    catch (error) {
        throw new Error(error.message)
    }
})

export const likeComment = createAsyncThunk('comment/like', async (commentId) => {
    try {
        const request = await apiInstance.post(`/api/post/comments/${commentId}/like`);
        const response = request.data;
        // console.log('comment like response ', response)
        if (response.status === 'success') {
            return response.message
        } else {
            throw new Error(response.message)
        }
    }
    catch (error) {
        console.log('comment like error ', error.message)
        throw new Error(error.message)
    }
})

export const unlikeComment = createAsyncThunk('comment/unlike', async (commentId) => {
    try {
        const request = await apiInstance.delete(`/api/post/comments/${commentId}/unlike`);
        const response = request.data;
        // console.log('comment unlike response ', response)
        if (response.status === 'success') {
            return response.message
        } else {
            throw new Error(response.message)
        }
    }
    catch (error) {
        console.log('comment like error ', error.message)
        throw new Error(error.message)
    }
})

export const getCommentReplies = createAsyncThunk('comment/reply/get', async (commentId) => {
    try {
        const request = await apiInstance.get(`/api/post/comments/${commentId}/replies`)
        const response = request.data

        // console.log('get comments reply response ', response)
        if (response.status === 'success') {
            return response.replies
        } else {
            throw new Error(response.message)
        }
    }
    catch (error) {
        console.log('get comment reply error ', error.message)
        throw new Error(error.message)
    }
})

export const replyComment = createAsyncThunk('comment/reply', async ({ postId, commentId, comment }) => {
    try {
        const request = await apiInstance.post(`/api/post/posts/${postId}/comments/${commentId}/reply`, comment);
        const response = request.data;
        // console.log('comment reply response ', response)
        if (response.status === 'success') {
            return response.reply
        } else {
            throw new Error(response.message)
        }
    }
    catch (error) {
        // console.log('comment reply error ', error.message)
        throw new Error(error.message)
    }
})

export const deleteComment = createAsyncThunk('comment/delete', async (commentId) => {
    try {
        const request = await apiInstance.delete(`/api/post/comment/${commentId}`);
        const response = request.data;
        // console.log('comment deleted response ', response)
        if (response.status === 'success') {
            return response.message
        } else {
            throw new Error(response.message)
        }
    }
    catch (error) {
        throw new Error(error.message)
    }
})

export const deleteCommentReply = createAsyncThunk('comment/reply', async ({ replyId }) => {
    try {
        const request = await apiInstance.delete(`/api/post/comments/reply/${replyId}`);
        const response = request.data;
        console.log('reply deleted response ', response)
        if (response.status === 'success') {
            return response.message
        } else {
            console.log('reply  deleted error ', response.message)
            throw new Error(response.message)
        }
    }
    catch (error) {
        console.log('reply delete error ', error.message)
        throw new Error(error.message)
    }
})